// src/pages/TwoFAResetPage/TwoFAResetPage.tsx
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'; // ← useHistory ではなく useNavigate
import { confirm2FARecovery } from '../../services/twoFactorAuthService';
import './TwoFAResetPage.css';
import Button from '../../components/Button';
import LoadingIndicator from '../../components/LoadingIndicator';

const TwoFAResetPage: React.FC = () => {
  const query = new URLSearchParams(useLocation().search);
  const token = query.get('token') || '';
  const navigate = useNavigate(); // ← ここ
  const [status, setStatus] = useState<'pending' | 'success' | 'error'>(
    'pending'
  );

  useEffect(() => {
    confirm2FARecovery({ token })
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [token]);

  if (status === 'pending') {
    return (
      <div className="reset-container">
        <LoadingIndicator size={32} />
        <p className="reset-message">処理中…お待ちください</p>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="reset-container">
        <p className="reset-error">リンクが無効か期限切れです。</p>
        <Button onClick={() => navigate('/login')}>ログイン画面へ</Button>
      </div>
    );
  }

  return (
    <div className="reset-container">
      <p className="reset-success">2FA のリセットに成功しました。</p>
      <Button onClick={() => navigate('/login')}>ログイン画面へ</Button>
    </div>
  );
};

export default TwoFAResetPage;
